// This pkg is used in the app (inside Nextcloud)
export const MODE_APP = 'app';
// It is used within the website (gatsby or volto)
export const MODE_WEBSITE = 'website';
